import React, { Component } from 'react';

import PropTypes from 'prop-types';
import assign from 'object-assign';

import { Link } from 'react-router';
import { statusColours } from '../../constants/ColourConstants';
import buildContextMenu from '../Common/BuildContextMenu';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import DetailView from '../Common/DetailView';
import EventWrapper from '../Event/EventWrapper';
import EventDialog from '../Event/EventDialog';

import TrainerIcon from 'material-ui/svg-icons/social/person';
import ScheduleIcon from 'material-ui/svg-icons/communication/clear-all';
import CalendarIcon from 'material-ui/svg-icons/action/date-range';
import CancelIcon from 'material-ui/svg-icons/navigation/cancel';

import BigCalendar from 'react-big-calendar';
import moment from 'moment';
import EventStore from '../../stores/EventStore';
import EventActions from '../../actions/EventActionCreator';

import 'react-big-calendar/lib/css/react-big-calendar.css';
import ROLES from '../../constants/Roles';

const localizer = BigCalendar.momentLocalizer(moment);

const getDateLimits = function(date, view) {
    let limits = {};
    if (!(date instanceof Date)) {
        date = new Date(date);
    }
    switch (view) {

        case 'agenda':
            limits.startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate()-1);
            limits.endDate   = new Date(date.getFullYear(), date.getMonth() + 1, 6);
            break;

        case 'day':
            limits.startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate()-1);
            limits.endDate   = new Date(date.getFullYear(), date.getMonth(), date.getDate()+1);
            break;

        case 'week':
            limits.startDate = new Date(date.getFullYear(), date.getMonth(), date.getDate()-6);
            limits.endDate   = new Date(date.getFullYear(), date.getMonth(), date.getDate()+6);
            break;

        case 'month':
        default:
            limits.startDate = new Date(date.getFullYear(), date.getMonth(), -6);
            limits.endDate   = new Date(date.getFullYear(), date.getMonth() + 1, 6);
            break;
    }

    limits.startDate = limits.startDate.toISOString();
    limits.endDate = limits.endDate.toISOString();

    return limits;
};

const style = {
    icon: {
        height: '32px',
        width: '32px',
    }
};
const formats = {

};


class TrainerCalendar extends Component {

    constructor() {
        super(...arguments);
        this.state = {events: []};
    }

    componentDidMount() {
        this.onEventsChange = this.onEventsChange.bind(this);
        this.eventPropGetter = this.eventPropGetter.bind(this);
        this.onNavigate = this.onNavigate.bind(this);
        this.onSelectEvent = this.onSelectEvent.bind(this);
        this.convertEvent = this.convertEvent.bind(this);

        EventActions.getTrainersEvents(getDateLimits(new Date(), 'month'));
        EventStore.addChangeListener(this.onEventsChange);
    }

    componentWillUnmount() {
        EventStore.removeChangeListener(this.onEventsChange);
    }
    
    render() {

        const actions = buildContextMenu(this.getActions(), this.context.auth);
        const scrollToTime = new Date();
        scrollToTime.setHours(6);

        return(
            <DetailView
                backButton={true}
                backTo="/dashboard/trainers"
                actions={actions}
            >
                <div className='cent-cards'>
                    <Card className="cent-card">
                        <CardHeader
                            title="Calendar"
                            subtitle={<Link to={`/dashboard/trainers`}>trainers</Link>}
                            avatar={<CalendarIcon style={style.icon} color={statusColours.default}/>}
                        />
                        <div className="cent-card-header-buttons">
                            <Link to={`/dashboard/trainers/schedule`}>
                                <ScheduleIcon className='cent-icon' color={statusColours.default}/>
                            </Link>
                        </div>
                        <CardText className="cent-card-calendar">
                            <BigCalendar
                                localizer={localizer}
                                popup
                                popupOffset={20}
                                formats={formats}
                                views={['month', 'week', 'day']}
                                selectable
                                events={this.state.events}
                                defaultView='month'
                                defaultDate={new Date()}
                                onNavigate={this.onNavigate}
                                eventPropGetter={this.eventPropGetter}
                                components={{eventWrapper: EventWrapper}}
                                scrollToTime={scrollToTime}
                            />
                        </CardText>
                    </Card>
                </div>
                <EventDialog
                    event={this.state.selectedEvent}
                    onClose={() => this.onSelectEvent()}
                    editLink={(ROLES.ADMIN && this.state.selectedEvent && `/dashboard/event/${this.state.selectedEvent.id}/edit`) || null}
                />
            </DetailView>
        )
    }

    convertEvent(event) {
        let eventData = {
            id:    event.id,
            start: new Date(event.eventStart || event.timeStart),
            end:   new Date(event.eventEnd || event.timeEnd),
            title: `${event.trainerFirstName} ${event.trainerLastName}`,
            url:   `/dashboard/event/${event.id}`,
            selectAction: () => this.onSelectEvent(event.id)
        };
        if (eventData.start.toLocaleTimeString() === "00:00:00" && eventData.end.toLocaleTimeString() === "00:00:00") {
            eventData.allDay = true;
        }

        let initial = event.trainerLastName.substring(0,1).toLowerCase();
        eventData.class = `style_${initial}`;

        return eventData;
    };

    onEventsChange() {
        const events = EventStore.getTrainerEvents();
        if (events !== undefined) {
            const state = assign(this.state, {events: events.map(this.convertEvent)});
            this.setState(state);
        }
    }

    onNavigate(date, view) {
        EventActions.getTrainersEvents(getDateLimits(date, view));
    }

    eventPropGetter(event, startDate, endDate, selected) {
        let prop = {};
        if (endDate.getTime() < Date.now()) {
            prop.className = `${event.class}_`;
        } else {
            prop.className = event.class;
        }
        return prop;
    }

    onSelectEvent(eventId) {
        this.setState({selectedEvent: (!!eventId && EventStore.getById(eventId)) || null});
    }

    getActions() {
        return [
            {
                link: '/dashboard/trainers',
                icon: <TrainerIcon />,
                label: 'Trainers',
            },
            { type: 'divider' },
            {
                link: '/logout',
                icon: <CancelIcon />,
                label: 'Sign out',
            },
        ];
    }
}

TrainerCalendar.contextTypes = {
    auth:       PropTypes.object
};

export default TrainerCalendar;

